import React from 'react';
import { Match } from './championship/Match';
export const ChampionShip = (props) => <table className='l-t'>
      <tbody>
         <tr>
            <th className={`l-td l-td-s-${props.sportID} l-s-r-${props.sportID}`} colSpan={3}>
               <div className={`l-d`}>
                  <div className={`l-s-c-i f-s-ico-${props.sportID}`}/>
                  <span className='l-t-i-n'> {props.toLocale(props.text) || props.enName} </span>
               </div>
            </th>
         </tr>
         {props.matches.map((match) => <Match {...match} key={`match_${match.id}`} championshipID={props.id} foldable={props.foldable} toLocale={props.toLocale} sportID={props.sportID} onClick={props.onClick} getInfo={props.getInfo}/>)}
      </tbody>
   </table>;



// WEBPACK FOOTER //
// ./src/web-frontend-components/results/live/tables/Championship.jsx